"use client";
import {
  DisclosureContextProvider,
  DisclosureScopedContextProvider
} from "./J55AVALY.js";
import {
  createStoreContext
} from "./5M6RSQEC.js";

// src/dialog/dialog-context.tsx
import { createContext } from "react";
var ctx = createStoreContext(
  [DisclosureContextProvider],
  [DisclosureScopedContextProvider]
);
var useDialogContext = ctx.useContext;
var useDialogScopedContext = ctx.useScopedContext;
var useDialogProviderContext = ctx.useProviderContext;
var DialogContextProvider = ctx.ContextProvider;
var DialogScopedContextProvider = ctx.ScopedContextProvider;
var DialogHeadingContext = createContext(void 0);
var DialogDescriptionContext = createContext(void 0);

export {
  useDialogContext,
  useDialogScopedContext,
  useDialogProviderContext,
  DialogContextProvider,
  DialogScopedContextProvider,
  DialogHeadingContext,
  DialogDescriptionContext
};
